import {
  NumberInputContainer,
  ButtonsContainer,
  ButtonContainer,
  InputContainer,
} from './NumberInput.styles';

type INumberInput = {
  value: number;
  labelText?: string;
  onClickRight?: () => void;
  onClickLeft?: () => void;
  children?: React.ReactNode;
};

export const NumberInput = ({
  value,
  labelText,
  onClickLeft,
  onClickRight,
  children,
}: INumberInput) => {
  return (
    <InputContainer>
      <NumberInputContainer>
        <label>{labelText}</label>
        <ButtonsContainer>
          <ButtonContainer padding="0.3rem 0.65rem" onClick={onClickLeft}>
            -
          </ButtonContainer>
          {value}
          <ButtonContainer padding="0.3rem 0.55rem" onClick={onClickRight}>
            +
          </ButtonContainer>
        </ButtonsContainer>
      </NumberInputContainer>
      {children ?? null}
    </InputContainer>
  );
};
